import React, { useState } from "react";
import "./BaltistanValley.scss";
import { FiChevronRight } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Helmet } from "react-helmet";

// Gallery Images
const basePath = "/Pictures/Treks/Challenging/K2"
const galleryImages = [
`${basePath}/k2.jpeg`,
`${basePath}/K2Base.jpg`,
`${basePath}/K2BaseCamp.jpg`,
`${basePath}/K2Basecamptrek.jpeg`,
`${basePath}/K2BaseCampTrek.jpg`,
`${basePath}/K2BaseCampTrekking.jpg`,
`${basePath}/K2camp.jpg`,
`${basePath}/K2Pakistan.jpeg`,
`${basePath}/K2trek.jpeg`,
`${basePath}/K2Trek.jpeg`,

];

const BaltistanValley = () => {
  const [showGallery, setShowGallery] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  return (
    <>
      <div className="ExploreBaltistanSlider">
        <Helmet>
          <title>Explore Baltistan Valley | Blog | World Adventures Tours</title>
          <meta
            name="description"
            content="Discover the hidden beauty of Baltistan Valley — where mountains meet magic. Explore its culture, lakes, traditions, and trekking routes in this detailed blog."
          />
          <meta property="og:title" content="Explore Baltistan Valley | Blog | World Adventures Tours" />
          <meta
            property="og:description"
            content="A complete guide to exploring Baltistan Valley, the gem of Northern Pakistan. Discover its villages, crystal lakes, and warm hospitality."
          />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://www.worldadventurestours.com/Blogs/ExploreBaltistanValley" />
        </Helmet>

        <div className="ExploreBaltistanBackground" onClick={() => setShowGallery(true)}></div>
        <div className="baltistanGallary">
          <button onClick={() => setShowGallery(true)}>Gallery</button>
        </div>
        <div className="baltistanHeading">
          <h1>Explore Baltistan Valley</h1>
        </div>
      </div>

      <div className="overview-container">
        <h2 className="overview-title">Overview</h2>

        <div className="overview-section">
          <h3>About Baltistan Valley</h3>
          <p>
            Nestled in the mighty Karakoram Range, Baltistan Valley is known as the “Land of Giants.”
            Home to K2, Broad Peak, and countless glaciers, Baltistan offers a mesmerizing combination
            of towering peaks, turquoise lakes, and rich Balti culture. From the bustling city of Skardu
            to the peaceful villages of Shigar and Khaplu, every corner of Baltistan tells a story of nature’s beauty and human resilience.
          </p>
        </div>

        <div className="key-highlights">
          <h3>Key Highlights</h3>
          <ul>
            <li><FiChevronRight /> Witness snow-capped peaks of the Karakoram Range.</li>
            <li><FiChevronRight /> Visit ancient forts like Shigar and Khaplu Fort.</li>
            <li><FiChevronRight /> Enjoy boating at Shangrila and Satpara Lake.</li>
            <li><FiChevronRight /> Trek to mesmerizing valleys like Basho, Kachura, and Hushe.</li>
            <li><FiChevronRight /> Experience local Balti hospitality and traditional cuisine.</li>
          </ul>
        </div>

        <div className="overview-section">
          <h3>Culture and People</h3>
          <p>
            The Balti people are known for their warmth, simplicity, and rich traditions.
            Their culture reflects a blend of Tibetan and Central Asian influences.
            Colorful festivals, traditional music, and handmade crafts add charm to the valley’s atmosphere.
          </p>
        </div>

        <div className="who-is-it-for">
          <h3>Who Should Visit Baltistan?</h3>
          <ul>
            <li><FaArrowRight /> Adventure seekers and nature lovers.</li>
            <li><FaArrowRight /> Photographers looking for raw landscapes.</li>
            <li><FaArrowRight /> Trekking enthusiasts exploring Pakistan’s northern gems.</li>
            <li><FaArrowRight /> Culture lovers interested in mountain life and traditions.</li>
            <li><FaArrowRight /> Families seeking peaceful and scenic holidays.</li>
          </ul>
        </div>

        <div className="overview-section">
          <h3>Top Places to Visit in Baltistan</h3>
          <ul>
            <li><FaArrowRight /> Skardu City and Satpara Lake</li>
            <li><FaArrowRight /> Shangrila (Lower Kachura Lake)</li>
            <li><FaArrowRight /> Upper Kachura Lake</li>
            <li><FaArrowRight /> Shigar Valley and Fort</li>
            <li><FaArrowRight /> Khaplu Valley and Palace</li>
            <li><FaArrowRight /> Basho and Deosai Plains</li>
          </ul>
        </div>

        <div className="overview-section">
          <h3>Best Time to Visit</h3>
          <p>
            The best time to explore Baltistan is from **May to October**, when the weather is pleasant and the roads are open.
            In summer, the valleys are lush green and rivers are at their most vibrant. Winter brings snow-covered beauty but limited access.
          </p>
        </div>

        <div className="overview-section">
          <h3>Plan Your Trip</h3>
          <p>
            Whether you’re seeking adventure or tranquility, Baltistan has something for everyone.
            Join <strong>World Adventures Tours</strong> for a guided journey to discover the wonders of Northern Pakistan.
            Let us plan your dream trip filled with breathtaking sceneries and unforgettable memories.
          </p>
        </div>
      </div>

      {showGallery && (
        <div className="gallery-modal">
          <div className="gallery-content">
            <button className="close-btn" onClick={() => setShowGallery(false)}>
              <ImCross />
            </button>
            <button className="prev-btn" onClick={handlePrevImage}>
              &lt;
            </button>
            <img src={galleryImages[currentImageIndex]} alt="Baltistan Gallery" />
            <button className="next-btn" onClick={handleNextImage}>
              &gt;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BaltistanValley;
